"use strict";

import { createRuntimeFn as _7a468 } from "@vanilla-extract/recipes/createRuntimeFn";
export var container = "TextInput_container__1rt9y8j0";
export var element = _7a468({
  defaultClassName: "TextInput_element__1rt9y8ji",
  variantClassNames: {
    position: {
      start: "TextInput_element_position_start__1rt9y8jj",
      end: "TextInput_element_position_end__1rt9y8jk"
    }
  },
  defaultVariants: {},
  compoundVariants: []
});
export var error = "TextInput_error__1rt9y8jl";
export var errorIcon = "TextInput_errorIcon__1rt9y8jm";
export var input = _7a468({
  defaultClassName: "TextInput_input__1rt9y8j8",
  variantClassNames: {
    size: {
      "x-small": "TextInput_input_size_x-small__1rt9y8j9",
      small: "TextInput_input_size_small__1rt9y8ja",
      medium: "TextInput_input_size_medium__1rt9y8jb",
      large: "TextInput_input_size_large__1rt9y8jc"
    },
    variant: {
      bordered: "TextInput_input_variant_bordered__1rt9y8jd",
      underlined: "TextInput_input_variant_underlined__1rt9y8je",
      borderless: "TextInput_input_variant_borderless__1rt9y8jf"
    }
  },
  defaultVariants: {},
  compoundVariants: []
});
export var inputWrapper = _7a468({
  defaultClassName: "TextInput_inputWrapper__1rt9y8j2",
  variantClassNames: {
    size: {
      "x-small": "TextInput_inputWrapper_size_x-small__1rt9y8j3",
      small: "TextInput_inputWrapper_size_small__1rt9y8j4",
      medium: "TextInput_inputWrapper_size_medium__1rt9y8j5",
      large: "TextInput_inputWrapper_size_large__1rt9y8j6"
    }
  },
  defaultVariants: {},
  compoundVariants: []
});
export var label = "TextInput_label__1rt9y8j7";
export var underline = _7a468({
  defaultClassName: "TextInput_underline__1rt9y8jg",
  variantClassNames: {
    focused: {
      true: "TextInput_underline_focused_true__1rt9y8jh"
    }
  },
  defaultVariants: {},
  compoundVariants: []
});